import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  List,
  ListItem,
  ListItemText,
  Container,
  Link,
  Button,
  Grow,
  Hidden,
  IconButton,
  ListItemIcon,
  ClickAwayListener
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./styles";
import logo from "../../assets/images/logo_saludsa_home.svg";
import { MenuPlans } from "./MenuPlans/index";
import { MedicalAssistence } from "./MedicalAssistence";
import { Vitality } from "./Vitality";
import { MenuServices } from "./MenuServices";
import DrawerAppBar from "./DrawerAppBar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PersonIcon from "@material-ui/icons/Person";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { MedicalAssistencePlans } from "./MedicalAssistencePlans";

const navLinksLeft = [
  { title: `Personas`, path: `/`, active: true },
  { title: `Empresas`, path: `/home_empresas`, active: false },
  { title: `Prestadores`, path: `/soy-prestador-medico`, active: false }
];
const navLinksRight = [
  { title: `¿Quiénes somos?`, path: `/quienes-somos/` },
  {
    title: `Blog`,
    path: `https://blog.saludsa.com/?__hstc=213659531.f1a25314a93e8960690d4f87c24f8f56.1620657222726.1620661494157.1620667209654.3&__hssc=213659531.5.1620667209654&__hsfp=3955714536`
  },
  { title: `Contactos`, path: `/contactos/` },
  // { title: `Buscar`, path: `/` },
  { title: `Acceso a clientes`, path: `/` }
];

const menuLinks = [
  { title: `Planes`, path: `/`, id: 1 },
  { title: `Vitality`, path: `/`, id: 2 },
  { title: `Asistencia médica`, path: `/`, id: 3 },
  { title: `Canales y servicios`, path: `/`, id: 4 }
  // { title: `Cómo usar mi plan`, path: `/`, id: 5 }
];
export const Navbar = () => {
  const classes = styles();
  const [openMenuItem, setOpenMenunItem] = useState(false);
  const [openMenuItemCliente, setOpenMenuItemClientes] = useState(false);
  const [itemSelected, setItemSelected] = useState(0);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [selectedPlan, setSelectedPlan] = useState(0);

  //HIDE MENU SCROLL
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleMenuDebounce = () => {
    const currentScrollPos = window.pageYOffset;

    setVisible(prevScrollPos - currentScrollPos > 0 || currentScrollPos < 10);

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleMenuDebounce);

    return () => window.removeEventListener("scroll", handleMenuDebounce);
  }, [prevScrollPos, visible]);

  const handleOpenMenu = id => {
    if (id === itemSelected) {
      setSelectedPlan(0);
      setOpenMenunItem(false);
      setItemSelected(0);
    } else {
      setOpenMenunItem(true);
      setItemSelected(id);
      setSelectedPlan(id);
    }
  };

  const handleClickAway = () => {
    setItemSelected(0);
    setSelectedPlan(0);
  };

  const handleOpenMenuClientes = () => {
    setOpenMenuItemClientes(!openMenuItemCliente);
  };

  const handleClickAwayClients = () => {
    setOpenMenuItemClientes(false);
  };

  const handleRenderMenu = () => {
    switch (itemSelected) {
      case 1:
        return (
          <MenuPlans handleClickAway={handleClickAway} visible={visible} />
        );
      case 2:
        return <Vitality handleClickAway={handleClickAway} visible={visible} />;
      case 3:
        return (
          <MedicalAssistencePlans
            handleClickAway={handleClickAway}
            visible={visible}
          />
        );
      case 4:
        return (
          <MenuServices handleClickAway={handleClickAway} visible={visible} />
        );
      default:
        return <div></div>;
      // return <div className={classes.absoluteSContainer}>Menu</div>;
    }
  };

  const handleRenderMenuClients = () => {
    return <div className={classes.accessClientsLinksContainer}></div>;

    // return <div className={classes.absoluteSContainer}>Menu</div>;
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div>
      <AppBar
        className={classes.headerClass}
        style={{ top: visible ? "0" : "-93px" }}
      >
        <Toolbar className={classes.toolbarStyle}>
          <Container className={classes.navbarDisplayFlex}>
            <List
              component="nav"
              aria-labelledby="main navigation"
              className={classes.navDisplayFlex}
            >
              {navLinksLeft.map(({ title, path, active }) => (
                <Link
                  href={path}
                  key={title}
                  color="inherit"
                  className={active ? classes.activeLinkText : classes.linkText}
                >
                  <ListItem button className={classes.linkMainHeaderText}>
                    <ListItemText primary={title} />
                  </ListItem>
                </Link>
              ))}
            </List>
            <Hidden only={["md", "lg", "xl"]}>
              <div className={classes.accessClients}>
                <Link
                  href="/"
                  color="inherit"
                  className={
                    openMenuItemCliente
                      ? classes.linkTextAccesoClientesOpen
                      : classes.linkTextAccesoClientes
                  }
                  onClick={e => {
                    e.preventDefault();
                    handleOpenMenuClientes();
                  }}
                >
                  <PersonIcon
                    className={
                      openMenuItemCliente
                        ? classes.iconUrl
                        : classes.iconUrlOpen
                    }
                  />
                </Link>
                {openMenuItemCliente && (
                  <Grow
                    in={openMenuItemCliente}
                    // style={{
                    //   transformOrigin: "0 0 0"
                    // }}
                    // {...(openMenuItem ? { timeout: 3000 } : {})}
                  >
                    <ClickAwayListener onClickAway={handleClickAwayClients}>
                      <div className={classes.accessClientsLinksContainer}>
                        <a
                          href="https://www.saludsapersonas.com/portalclientes/Account/Login"
                          className={classes.textoMenuAccesoCliente}
                        >
                          <div>Soy cliente</div>
                          <ArrowForwardIosIcon
                            className={classes.idFlechaMenuAcceso}
                          />
                        </a>
                        <a
                          href="/soy-prestador-medico/"
                          className={classes.textoMenuAccesoCliente}
                        >
                          <div>Soy prestador médico</div>
                          <ArrowForwardIosIcon
                            className={classes.idFlechaMenuAcceso}
                          />
                        </a>
                        <a
                          href="https://www.saludsaempresas.com/PortalBrokers/Views/Login.html"
                          className={classes.textoMenuAccesoCliente}
                        >
                          <div>Soy broker de seguros</div>
                          <ArrowForwardIosIcon
                            className={classes.idFlechaMenuAcceso}
                          />
                        </a>
                        <a
                          href="https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10"
                          className={classes.textoMenuAccesoCliente}
                          style={{
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px"
                          }}
                        >
                          <div>Chat servicio al cliente</div>
                          <ArrowForwardIosIcon
                            className={classes.idFlechaMenuAcceso}
                          />
                        </a>
                      </div>
                    </ClickAwayListener>
                  </Grow>
                )}
              </div>
            </Hidden>

            <Hidden only={["sm", "xs"]}>
              <List
                component="nav"
                aria-labelledby="main navigation"
                className={classes.navDisplayFlex}
              >
                {navLinksRight.map(({ title, path }) =>
                  title === "Acceso a clientes" ? (
                    <div className={classes.accessClients} key={title}>
                      <Link
                        href={path}
                        key={title}
                        color="inherit"
                        className={
                          openMenuItemCliente
                            ? classes.linkTextAccesoClientesOpen
                            : classes.linkTextAccesoClientes
                        }
                        onClick={e => {
                          e.preventDefault();
                          handleOpenMenuClientes();
                        }}
                      >
                        <PersonIcon
                          className={
                            openMenuItemCliente
                              ? classes.iconUrl
                              : classes.iconUrlOpen
                          }
                          style={{ marginRight: "-10px", fontSize: 24 }}
                        />
                        <ListItem button>
                          <ListItemText primary={title} />
                        </ListItem>
                      </Link>
                      {openMenuItemCliente && (
                        <Grow
                          in={openMenuItemCliente}
                          // style={{
                          //   transformOrigin: "0 0 0"
                          // }}
                          // {...(openMenuItem ? { timeout: 3000 } : {})}
                        >
                          <ClickAwayListener
                            onClickAway={handleClickAwayClients}
                          >
                            <div
                              className={classes.accessClientsLinksContainer}
                            >
                              <a
                                href="https://www.saludsapersonas.com/portalclientes/Account/Login"
                                className={classes.textoMenuAccesoCliente}
                              >
                                <div>Soy cliente</div>
                                <ArrowForwardIosIcon
                                  className={classes.idFlechaMenuAcceso}
                                />
                              </a>
                              <a
                                href="/soy-prestador-medico/"
                                className={classes.textoMenuAccesoCliente}
                              >
                                <div>Soy prestador médico</div>
                                <ArrowForwardIosIcon
                                  className={classes.idFlechaMenuAcceso}
                                />
                              </a>
                              <a
                                href="https://www.saludsaempresas.com/PortalBrokers/Views/Login.html"
                                className={classes.textoMenuAccesoCliente}
                              >
                                <div>Soy broker de seguros</div>
                                <ArrowForwardIosIcon
                                  className={classes.idFlechaMenuAcceso}
                                />
                              </a>
                              <a
                                href="https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10"
                                className={classes.textoMenuAccesoCliente}
                                style={{
                                  borderBottomLeftRadius: "8px",
                                  borderBottomRightRadius: "8px"
                                }}
                              >
                                <div>Chat servicio al cliente</div>
                                <ArrowForwardIosIcon
                                  className={classes.idFlechaMenuAcceso}
                                />
                              </a>
                            </div>
                          </ClickAwayListener>
                        </Grow>
                      )}
                    </div>
                  ) : (
                    <Link
                      href={path}
                      key={title}
                      color="inherit"
                      className={classes.linkText}
                    >
                      <ListItem button className={classes.linkMainHeaderText}>
                        <ListItemText primary={title} />
                      </ListItem>
                    </Link>
                  )
                )}
              </List>
            </Hidden>
          </Container>
        </Toolbar>
        <Toolbar className={classes.toolbarSecondStyle}>
          <Container className={classes.navbarDisplayFlex}>
            <div className={classes.logoMainContainer}>
              <a
                href={`${process.env.REACT_APP_URL_HOST}`}
                className={classes.logoContainer}
              >
                <img src={logo} alt="Logo saludsa" />
              </a>
            </div>
            {/* MENU PRINCIPAL DESKTOP */}
            <Hidden only={["sm", "xs"]}>
              <List
                component="nav"
                aria-labelledby="second navigation"
                className={classes.navDisplayFlex}
                style={{ width: "75%", paddingRight: "20px" }}
              >
                {menuLinks.map(({ title, path, id }) => (
                  <Link
                    href={`${process.env.REACT_APP_URL_HOST}${path}`}
                    onClick={e => {
                      if (id === 1 || id === 2 || id === 3 || id === 4) {
                        e.preventDefault();
                        handleOpenMenu(id);
                      }
                    }}
                    key={title}
                    className={classes.linkTextSecond}
                  >
                    <ListItem button className={classes.itemMainMenu}>
                      <ListItemText
                        primary={title}
                        style={{ marginBottom: 0 }}
                      />
                      <ListItemIcon className={classes.containerIconArrowMain}>
                        <ExpandMoreIcon
                          className={
                            selectedPlan === id
                              ? classes.activeArrowPlan
                              : classes.iconArrowMainMenu
                          }
                        />
                      </ListItemIcon>
                      {selectedPlan === id ? (
                        <div className={classes.lineActivePlan} />
                      ) : (
                        ""
                      )}
                    </ListItem>
                  </Link>
                ))}
                <Link
                  href={"/como-usar-tu-plan/"}
                  className={`${classes.itemMainMenu} ${classes.uniqueLink}`}
                >
                  Cómo usar mi plan
                  <ExpandMoreIcon style={{ color: "white" }} />
                </Link>
                <Button
                  variant="contained"
                  className={`popmake-251377 ${classes.buttonStyle}`}
                >
                  Obtén una cotización
                </Button>
              </List>
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                style={{ paddingRight: 30 }}
              >
                {!mobileOpen ? (
                  <MenuIcon className={classes.hamburguerMenu} />
                ) : (
                  <CloseIcon className={classes.hamburguerMenu} />
                )}
              </IconButton>
            </Hidden>
          </Container>
          {openMenuItem && (
            <Grow
              in={openMenuItem}
              style={{
                transformOrigin: "0 0 0"
              }}
              {...(openMenuItem ? { timeout: 3000 } : {})}
            >
              {handleRenderMenu()}
            </Grow>
          )}
        </Toolbar>
      </AppBar>

      {/* <Hidden smUp> */}
      <DrawerAppBar
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
      />
      {/* </Hidden> */}
    </div>
  );
};
